import React from "react";
import styled from "styled-components";
import goBackIcon from "../../../images/goBackIcon.svg";
import Button from "../../../helpers/components/Button";
import { EditModal } from "../../shared/EditModal";
import { SharedButton } from "./shared/SharedButton";
import {
  BigHeaderText,
  FlexRowBetweenCenter,
  HeaderText,
  SmallText,
} from "../../shared/SharedStyles";
import deleteIcon from "../../../images/deleteIcon.svg";

interface DeleteAccountConfirmationProps {
  showModal: boolean;
  handleSetShowModal: () => void;
  handleActionClick: () => void;
  title: string;
  loading: boolean;
  paragraphText?: string;
  headerText?: string;
  /* Shown when the account still has a live store subscription. Deleting the
     account does not cancel it — the subscription belongs to the App Store or
     Play account, not to us, and billing continues until the person cancels it
     there. Saying nothing means they keep paying for something they believe
     they have left. */
  subscriptionWarning?: boolean;
  manageSubscriptionUrl?: string | null;
}

export const DeleteAccountConfirmation: React.FC<
  DeleteAccountConfirmationProps
> = ({
  showModal,
  handleSetShowModal,
  handleActionClick,
  title,
  loading,
  paragraphText,
  headerText,
  subscriptionWarning,
  manageSubscriptionUrl,
}) => {
  return (
    <EditModal isOpen={showModal} onClose={handleSetShowModal}>
      <HeaderContainer>
        <HeaderIcon src={goBackIcon} onClick={handleSetShowModal} />
        <BigHeaderText>{title}</BigHeaderText>
        <div></div>
      </HeaderContainer>
      <ConfirmationTextWrapper>
        <HeaderText>{headerText}</HeaderText>
        <SmallText>{paragraphText}</SmallText>
        {subscriptionWarning && (
          <SubscriptionNotice>
            <strong>Your subscription will not be cancelled.</strong> It is held
            by your app store account, so it keeps renewing until you cancel it
            there — deleting this account does not stop the payments.
            {manageSubscriptionUrl && (
              <>
                {" "}
                <a
                  href={manageSubscriptionUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cancel your subscription first
                </a>
                .
              </>
            )}
          </SubscriptionNotice>
        )}
      </ConfirmationTextWrapper>
      <ButtonsWrapper>
        <SharedButton
          iconSrc={deleteIcon}
          buttonText={"Delete"}
          onClick={() => handleActionClick()}
          $disabled={loading}
          loading={loading}
        />
        <Button $button_type="colored" onClick={handleSetShowModal}>
          Cancel
        </Button>
      </ButtonsWrapper>
    </EditModal>
  );
};

const HeaderContainer = styled.div`
  ${FlexRowBetweenCenter}
  padding: 16px 0;
  width: 100%;
`;

const HeaderIcon = styled.img`
  width: 20px;
  height: 20px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ConfirmationTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
`;

const SubscriptionNotice = styled.p`
  margin: 12px 0 0;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fbe8d9;
  color: #4a3628;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;

  a {
    color: #a8412a;
  }
`;
